<cam-form
  [inputs]="this.form()"
  [askValidation$]="this.askValidation()"
  [canDisplayButton]="false"
  [error]="this.error()"
  [loader]="this.loader()"
  (isFormValid)="this.isFormValid.emit($event)"
  (valid)="this.validation($event)"
></cam-form>

<ng-template #noteTypeTemplate let-item="item" [typedTemplate]="this.typeNoteTypeToken">
  <div class="g-space-sm">
    {{ item.denomination }}
  </div>
</ng-template>
